import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';


/*
 * Gatsby has 2 helpers for images ( https://www.gatsbyjs.com/plugins/gatsby-plugin-image/ )
 * - StaticImage: for assets. It resizes the image, but require string src without replace and not passed as prop. For this reason, and since our images are already sized, we dont't use it.
 * - GatsbyImage: for graphQL. It resizes the image (internally it uses StaticImage), but is only compatible with gatsbyImageData. Since blog images can be of any format, we use it
 */
export default function Image(props) {
    const { img, ...otherProps } = props;
    const [imageLoaded, setImageLoaded] = useState(false);
    const isDynamic = typeof img === 'object';  // from graphQL

    useEffect(() => {
        if (typeof img === 'string' && img && imageLoaded === false) {
            // load image
            import(`../assets/images/${img}`)
                .then((i) => setImageLoaded(i.default))
                .catch(console.error);
        }
    }, [img, imageLoaded]);

    if (!img) return null;

    const alt = /(\w+)\./.exec(isDynamic ? img.relativePath : img)?.[1] || 'image';

    return isDynamic
        ? (
            <GatsbyImage
                image={getImage(img)}
                alt={alt}
                imgClassName="!object-contain"
                {...otherProps}
            />
        )
        : (imageLoaded
            && (
            <img
                src={imageLoaded}
                alt={alt}
                {...otherProps}
            />
            )
        );
}

Image.propTypes = {
    img: PropTypes.any.isRequired,
};
